import { fork } from "typed-redux-saga";

import { fetchActiveStoreWatcher } from "./fetchActiveStoreSaga";

export function* activeStoreRootSaga() {
    // Starts watcher for `fetchActiveStore` actions.
    yield* fork(fetchActiveStoreWatcher);
}
